// Da Vinci Canvas (Main Editor Area)
import { DaVinciState } from "../core/DaVinciState.js";
import { DaVinciEvents } from "../core/DaVinciEvents.js";
import { DaVinciBlock } from "./DaVinciBlock.js";

export const DaVinciCanvas = {
    render() {
        const container = document.createElement('div');
        container.className = 'davinci-canvas-area';

        const paper = document.createElement('div');
        paper.className = 'davinci-paper';
        paper.id = "davinci-paper-root";

        // Title Input
        const titleInput = document.createElement('input');
        titleInput.type = 'text';
        titleInput.className = 'dv-text-block';
        titleInput.id = 'doc-title';
        titleInput.placeholder = '제목을 입력하세요';
        titleInput.style.cssText = "font-size: 2rem; font-weight: bold; margin-bottom: 40px; border-bottom: 1px solid #333; padding-bottom:10px;";
        titleInput.value = DaVinciState.get().title || '';
        titleInput.oninput = (e) => DaVinciState.setTitle(e.target.value);

        paper.appendChild(titleInput);

        // Blocks Container
        const blocksContainer = document.createElement('div');
        blocksContainer.id = 'davinci-blocks-container';
        paper.appendChild(blocksContainer);

        // End Marker
        const endMarker = document.createElement('div');
        endMarker.style.cssText = "height: 200px; display:flex; align-items:center; justify-content:center; color:#444; margin-top:50px";
        endMarker.innerHTML = `<span style="font-style:italic">작품의 끝 (End of Codex)</span>`;
        paper.appendChild(endMarker);

        container.appendChild(paper);

        // Initialize Sortable
        setTimeout(() => {
            if (window.Sortable) {
                new window.Sortable(blocksContainer, {
                    handle: '.handle',
                    animation: 150,
                    ghostClass: 'sortable-ghost',
                    onEnd: (evt) => {
                        // Sync State with DOM Order
                        // We need to re-read the IDs from DOM and update State blocks order
                        const newOrderIds = Array.from(blocksContainer.children).map(el => el.dataset.id);
                        const currentBlocks = DaVinciState.get().blocks;

                        // Sort currentBlocks based on newOrderIds
                        const sortedBlocks = newOrderIds.map(id => currentBlocks.find(b => b.id === id)).filter(b => b); // filter undefined just in case

                        DaVinciState.setBlocks(sortedBlocks);
                        DaVinciEvents.emit(DaVinciEvents.ON_BLOCK_MOVE); // Optional notification
                    }
                });
            }
        }, 100);

        // Store reference for updates
        this.containerInfo = { blocksContainer, titleInput };

        // Initial Render
        this.refreshBlocks();

        return container;
    },

    refreshBlocks() {
        if (!this.containerInfo || !this.containerInfo.blocksContainer) return;

        const { blocksContainer } = this.containerInfo;
        const blocks = DaVinciState.get().blocks;

        blocksContainer.innerHTML = '';
        blocks.forEach(block => {
            const blockEl = DaVinciBlock.render(block);
            blocksContainer.appendChild(blockEl);
        });
    },

    updateTitle(title) {
        if (this.containerInfo && this.containerInfo.titleInput) {
            if (this.containerInfo.titleInput.value !== title) {
                this.containerInfo.titleInput.value = title;
            }
        }
    }
};
